var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"dark":"","small":"","color":_vm.color},domProps:{"textContent":_vm._s(_vm.$t('lists.knowledgeType.' + _vm.value))}})}
var staticRenderFns = []

export { render, staticRenderFns }